<template>
  <div class="artist-detail">
    <b-container>
      <div
        v-if="!currentArtist"
      >
        Künstlerdaten werden geladen ...
      </div>
      <b-row
        v-if="currentArtist"
        class=""
      >
        <b-col
          md="12"
          class="mb-4 "
        >
          <h1
            class=""
          >
            {{ currentArtist.name}}
          </h1>
          <h4
            class=""
          >
            {{ bioDates }}
          </h4>
        </b-col>
      </b-row>
      <b-row
        v-if="currentArtist"
      >
        <b-col
          md=8
        >
          <b-row

          >
            <b-col
              v-if="!currentArtist.fsek_entries"
            >
              in Arbeit ...
            </b-col>
          </b-row>
          <b-row
            v-if="gnd"
          >
            <b-col>
              <div role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                      tag="div"
                      block 
                      href="#" 
                      v-b-toggle.accordion-2 
                      variant="light"
                      class="text-left d-flex justify-content-between "
                    >
                      <div
                        class=""
                      >
                        <h5
                          class="mb-4"
                        >
                          Referenzdaten<br />
                          <span class="small">(GND)</span>
                        </h5>
                      </div>
                      <div
                        class="align-self-end text-center px-2"
                      >
                        
                      </div>
                      <div 
                        class="align-self-end when-opened text-center"
                      >
                        schließen<br>
                        &uarr;
                      </div>
                      <div
                        class="align-self-end when-closed text-center"
                      >
                        anzeigen<br>
                        &darr;
                      </div>
                    </b-button>
                    
                  </b-card-header>
                  <b-collapse id="accordion-2"
                    accordion="my-accordion" 
                    role="tabpanel"
                    class="p-2"
                  >
                    <b-row>
                      <b-col
                        md="12"
                      >
                        <h5
                          class="mb-1"
                        >
                          Gemeinsame Normdatei (GND)
                        </h5>
                        <p>
                          <b-link
                            :href="gnd.id"
                            alt="Datensatz in der GND"
                            target="_blank"
                            class="small"
                          >
                            &rarr; Eintrag
                          </b-link>
                          </p>
                      </b-col>
                      <b-col
                        md="2"
                        class="font-weight-bold"
                      >
                        geboren:
                      </b-col>
                      <b-col
                        md="4"
                        class=""
                      >
                        {{ localeDate(gnd.DOB) }}
                      </b-col>
                      <b-col
                        md="2"
                        class="font-weight-bold"
                      >
                        Geburtsort:
                      </b-col>
                      <b-col
                        md="4"
                        class=""
                      >
                        {{ gnd.POB }}
                      </b-col>
                      <b-col
                        md="2"
                        class="font-weight-bold"
                      >
                        gestorben:
                      </b-col>
                      <b-col
                        md="4"
                        class=""
                      >
                        {{ localeDate(gnd.DOD) }}
                      </b-col>
                      <b-col
                        md="2"
                        class="font-weight-bold"
                      >
                        Sterbeort:
                      </b-col>
                      <b-col
                        md="4"
                        class=""
                      >
                        {{ gnd.POD }}
                      </b-col>
                    </b-row>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="currentArtist.fsek_entries"
          >
            <b-col
              md="12"
            >
              <div role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                      tag="div"
                      block 
                      href="#" 
                      v-b-toggle.accordion-1 
                      variant="light"
                      class="text-left d-flex justify-content-between "
                    >
                      <div
                        class=""
                      >
                        <h5
                          class="mb-4"
                        >
                          Einträge in der Datenbank zum Beschlagnahmeinventar<br>der Aktion "Entartete Kunst"<br>
                          <span class="small">Forschungsstelle "Entartete Kunst" der Freien Universität Berlin</span>
                        </h5>
                      </div>
                      <div
                        class="align-self-end text-center px-2"
                      >
                        <strong>{{ currentArtist.fsek_entries.length }}</strong><br>
                        <span v-if="currentArtist.fsek_entries.length === 1">Objekt</span><span v-else>Objekte</span>
                      </div>
                      <div 
                        class="align-self-end when-opened text-center"
                      >
                        schließen<br>
                        &uarr;
                      </div>
                      <div
                        class="align-self-end when-closed text-center"
                      >
                        anzeigen<br>
                        &darr;
                      </div>
                    </b-button>
                    
                  </b-card-header>
                  <b-collapse id="accordion-1"
                    accordion="my-accordion" 
                    role="tabpanel"
                    class="p-2"
                  >
                    <b-row
                      v-for="(entry, index) in currentArtist.fsek_entries"
                      :key="index"
                      class="mb-2 pb-2 mr-3"
                    >
                      <b-col
                        md="3"
                      >
                        <b-img
                          v-if="entry.image"
                          :src="entry.image"
                          class="d-block w-100"
                        />
                        <b-img
                          v-else
                          src="/img/work-of-art.jpg"
                          class="d-block w-100"
                        />
                      </b-col>
                      <b-col
                        md="9"
                        class=""
                      >
                        <h6>{{ entry.titel }}</h6>
                        <b-link
                          :href="entry.permalink"
                          target="_blank"
                        >
                          &rarr; zu diesem Eintrag in der FSEK-Datenbank
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          md="4"
          class="border-left"
        >
          <WikiImage
            v-if="currentArtist.image"
            :imageSource="currentArtist.wdItem"
            :commonsImage="currentArtist.image"
            class="mb-2"
          />
          <p
            class="lead mb-4"
          >
            {{ currentArtist.name }} in Wikipedia
          </p>
          <WikipediaArticles
            v-if="currentArtist.wikipediaArticles"
            :articles="currentArtist.wikipediaArticles"
            class="py-2"
          />
        </b-col>
      </b-row>
    </b-container>
    
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import WikiImage from '@/components/subparts/Wiki-image'
import WikipediaArticles from '@/components/subparts/Wikipedia-articles'
import axios from 'axios'

export default {
  name: 'artistDetail',
  components: {
    WikiImage,
    WikipediaArticles       
  },
  data () {
      return {
          artist: {},
          POB: '',
          POD: '',
          GNDData: null,
          GNDRawData: {}
      }
  },
  methods: {
    ...mapActions({
      
    }),
    setGNDData(payload) {
      const GNDData =
       {
          id: payload.id,
          POB: payload.placeOfBirth[0]['label'] || 'keine Angabe',
          POD: payload.placeOfDeath[0]['label'] || 'keine Angabe',
          DOB: payload.dateOfBirth[0] || 'keine Angabe',
          DOD: payload.dateOfDeath[0] || 'keine Angabe',
       }
      this.GNDRawData = payload
      this.GNDData = GNDData
    },
    fetchGNDData() {
      const gndurl = this.secondaryURLs.lobidGND + this.currentArtist.gndID + '.json'
      axios.get(gndurl, {
        params: {

        }
      })
        .then(response => {
           this.setGNDData(response.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    localeDate(d) {
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }
      let localeDate
      if (d.length > 4) {
        localeDate = new Date(d.replace('+','')).toLocaleString('de-DE', options)
      } else {
        localeDate = d
      }
      return localeDate
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      displayArtists: 'getDisplayArtists',
      secondaryURLs: 'getSecondaryURLs'
    }),
    currentArtist () {
      return this.displayArtists.find(a => a.slug === this.$route.params.slug) 
    },
    gnd () {
      return this.GNDData
    },
    bioDates() {
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }
      let dateOfBirth = new Date(this.currentArtist.dateOfBirth.replace('+','')).toLocaleString('de-DE', options)
      let dateOfDeath = new Date(this.currentArtist.dateOfDeath.replace('+','')).toLocaleString('de-DE', options)
      let POB = ''
      let POD = ''
      if (this.currentArtist.placeOfBirthLabel) {
        POB = `${this.currentArtist.placeOfBirthLabel} `
      }
      if (this.currentArtist.placeOfDeathLabel) {
        POD = `${this.currentArtist.placeOfDeathLabel} `
      }
      let bioDatesString = `
        ${POB}${dateOfBirth} - ${POD}${dateOfDeath}
      `
      return bioDatesString
    }
  },
  created () {
    if(this.currentArtist) {
      this.fetchGNDData()
    } 
  },
  updated () {
    if(this.currentArtist) {
      this.fetchGNDData()
    } 
  } 
}
</script>
<style>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
